RivalIQ.apps.Insights.module('curations', function (
    curations,
    App,
    Backbone,
    Marionette,
    $,
    _
) {
    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const channelWall = Dashboard.curations.filters.ChannelFilterFactory({
        template: '#widgetInsightsTwitterAuthTemplate',
        upsellTemplate: '#widgetInsightsTwitterUpsellTemplate',
        channel: RivalIQ.enums.sources.TWITTER_INSIGHTS
    });

    const page = RivalIQ.configuration.menus.getConfiguration().TWITTER_INSIGHTS;

    const baseFilterViewParams = {
        className: 'user-action-prompt widget-insights-nothing',
        ui: {
            manageAccounts: '.x-manage-accounts'
        },
        events: {
            'click @ui.manageAccounts': 'onManageAccounts'
        },
        regions: {
            mainView: '.main-view'
        },
        initialize: function () {
            const me = this;

            me.curation = me.options.curation;
        },
        onManageAccounts: function () {
            const source = RivalIQ.enums.sources.TWITTER_INSIGHTS;
            const model = RivalIQ.data.channels.get(source);
            RivalIQ.execute('show:modal', new RivalIQ.apps.AccountSettings.views.MultiTokenConnectionModal({
                model: model
            }));
        }
    };

    const viewParams = _.extend({}, baseFilterViewParams, {
        template: '#widgetTwitterInsightsNothingInLandscapeTemplate'
    });

    const expiredPresenceParams = _.extend({}, baseFilterViewParams, {
        template: '#widgetTwitterExpiredTokenTemplate',

        serializeData: function () {
            const me = this;

            return {
                handles: me.options.handles
            };
        }
    });

    const protectedAccountParams = _.extend({}, baseFilterViewParams, {
        template: '#widgetTwitterProtectedAccountTemplate',

        serializeData: function () {
            const me = this;

            return {
                handle: me.options.handle
            };
        }
    });

    const notInAccountViewParams = _.extend({}, baseFilterViewParams, {
        template: '#widgetTwitterInsightsNothingInAccountTemplate',
        serializeData: function () {
            const me = this;

            return {
                handle: me.options.handle
            };
        }
    });

    curations._BaseTwitterInsightsCuration = curations._BaseInsightsCuration.extend({
        beforeFilters: [
            curations.filters.twitterPresenceLoader,
            channelWall,
            curations.filters.noInsightsInAccount(notInAccountViewParams),
            curations.filters.expiredPresence(expiredPresenceParams),
            curations.filters.protectedAccount(protectedAccountParams),
            curations.filters.noInsightsInLandscape(viewParams),
            curations.filters.checkAccountAccessTwitter(
                RivalIQ.enums.sources.TWITTER_INSIGHTS,
                'widgetInsightsTwitterAuthTemplate'
            ),
            curations.filters.insightsLoading(
                RivalIQ.enums.sources.TWITTER_INSIGHTS,
                '/insights/twitter'
            )
        ],

        afterFilters: [
            RivalIQ.apps.Dashboard.curations.filters.updateShell
        ],

        source: RivalIQ.enums.sources.TWITTER_INSIGHTS,

        appTitle: 'Twitter Analytics',

        page: function () {
            const me = this;
            const clonedPage = _.cloneDeep(page);

            // hide if no presence or we have a presence but it's not fetched
            if (!me.presence || (me.presence && !_.get(me.presence, ['attributes', 'sources', me.source, 'fetched']))) {
                _.set(clonedPage, ['metadata', 'channelRedacted'], true);
            }

            return clonedPage;
        },

        title: page.name,
        exportTitle: 'Twitter Analytics',

        getBasePath: function (props) {
            const me = this;
            const defaults = {
                companyId: me.getProp('companyId')
            };
            return me.router.resolveCurationRoute(me.id, _.extend(defaults, props));
        },

        getTitleSlide: function () {
            const me = this;

            const companyId = me.getProp('companyId');
            const companyName = RivalIQ.state.landscape.getCompanyById(companyId).get('name');
            const handle = `@${_.get(me.presence.get('sources'), [me.source, 'handle'])}`;
            const landscapeName = RivalIQ.state.view.get('landscapeName');

            return new RivalIQ.apps.Reports.models.Slide({
                style: RivalIQ.apps.Reports.models.Slide.styleTypes.INTRO,
                elements: {
                    head: me.getPptTitle(),
                    date: me.getExportTitleBarTimePeriod(),
                    brand: RivalIQ.apps.Reports.models.Slide.brandImages.getLarge(),
                    focusCompanyTitle: 'Company',
                    focusCompany: companyName,
                    activeTagTitle: 'Handle', // reusing the intro slide layout with different data, hence the key name mismatch.
                    activeTag: handle,
                    landscapeTitle: 'Landscape',
                    landscape: _.unescape(landscapeName)
                }
            });
        },

        titleView: function () {
            const me = this;

            let options = {};
            // no dropdown if no presences in landscape
            if (me.presences && !me.presences.isEmpty()) {
                options = {
                    hasEditButton: true,
                    titleViewEditName: 'Manage Accounts'
                };
            }

            const switchable = me.getSwitchableTitleView(options);
            me.listenTo(switchable, 'title:edit', me.onTitleEdit);

            return switchable;
        },

        onTitleEdit: function () {
            const me = this;

            const source = RivalIQ.enums.sources.TWITTER_INSIGHTS;
            const model = RivalIQ.data.channels.get(source);

            const modal = new RivalIQ.apps.AccountSettings.views.MultiTokenConnectionModal({
                model: model,
                parentItem: me.switchable
            });

            me.listenTo(modal, 'click:done', me.reload);
            RivalIQ.execute('show:modal', modal);
        },

        formatPresence: function (currentPresence) {
            if (currentPresence) {
                const handle = currentPresence.get('screen_name');
                if (handle) {
                    return `@${handle}`;
                }
            }
        },

        getSwitchableItems: function () {
            const me = this;

            if (me.presences) {
                const companies = me.presences.map(function (presence) {
                    const company = RivalIQ.state.landscape.getCompanyById(presence.get('companyId'));
                    company.set('screen_name', presence.get('screen_name'));
                    return company;
                });

                return _(companies)
                    .sortBy(function (company) {
                        return company.get('name');
                    })
                    .map(function (company) {
                        const tableWidget = me.getWidget('posts-table');
                        const instanceId = me.getProp('instanceId');

                        return {
                            value: company.get('id'),
                            display: `@${company.get('screen_name')}`,
                            action: function () {
                                const companyId = company.get('id');
                                const path = me.getPath({
                                    companyId: companyId,
                                    presenceId: undefined,
                                    searchTerm: '',
                                    // only tack this on if we're switching in the details view of the table widget
                                    tableLayout: instanceId && tableWidget &&
                                        instanceId === tableWidget.getProp('instanceId') ? tableWidget.getProp('layout') : null
                                });

                                RivalIQ.execute(
                                    'tracking:push:auth',
                                    RivalIQ.tracking.metric.ChangedInsightsCompany, {
                                        company_id: companyId,
                                        channel: RivalIQ.enums.sourceDetails[
                                            RivalIQ.enums.sources.TWITTER_INSIGHTS
                                        ].channel
                                    }
                                );

                                me.saveLastSelectedInsightsPresence(companyId);
                                RivalIQ.execute('history:navigate', path, {
                                    trigger: true
                                });
                            }
                        };
                    })
                    .value();
            }
        }
    });
});
